import { SalesforceIconUrl } from "@p0security/integrations-salesforce-shared/icon";
import { registerIntegration } from "@p0security/shared/integrations/registry";
import {
  type AnyFilterSchema,
  Registration,
} from "@p0security/shared/integrations/types";

import { SalesforceAiAccesses } from "./accesses.ts";
import { SalesforceAiComponents } from "./components.ts";

const SalesforceAiFilters = {
  org: { keys: ["value"] },
  "permission-set": { keys: ["name"] },
} as const satisfies AnyFilterSchema;
export type SalesforceAiFilters = typeof SalesforceAiFilters;

export const SalesforceAiRegistration = Registration({
  accesses: SalesforceAiAccesses,
  category: "resource",
  components: SalesforceAiComponents,
  docs: {
    install: "agentic-gateway/mcp-server/salesforce",
    request: "agentic-gateway/requesting-access",
  },
  filters: SalesforceAiFilters,
  identifier: "My Domain name",
  itemKind: "organization",
  label: "Salesforce (AI)",
  logoUrl: SalesforceIconUrl,
  maturity: "beta",
  requestType: "requestable",
  useMapping: [{ use: "iam_write", component: "org" }],
});

registerIntegration("salesforce-ai", SalesforceAiRegistration);
